import useFetch from '../../hooks/useFetch'
import { urlApi } from '../../config'

function Stat({ label, value, tone }) {
  const color = tone === 'coral' ? 'text-coral' : 'text-ink dark:text-gray-100'
  return (
    <div>
      <p className='text-warm_gray dark:text-gray-400 text-[11px] font-semibold uppercase tracking-wider'>{label}</p>
      <p className={`font-display font-bold text-3xl leading-tight tabular-nums ${color}`}>{value ?? '—'}</p>
    </div>
  )
}

function RatioStat({ ratio }) {
  const pct = (ratio || 0) * 100
  const hot = pct >= 10
  return (
    <div>
      <p className='text-warm_gray dark:text-gray-400 text-[11px] font-semibold uppercase tracking-wider'>Ratio rech / proc</p>
      <p className={`font-display font-bold text-3xl leading-tight tabular-nums ${hot ? 'text-coral' : 'text-amber_deep'}`}>{pct.toFixed(1)}%</p>
      <div className='h-1.5 rounded-full bg-ink/10 dark:bg-dk-raised mt-2 overflow-hidden'>
        <div
          className={`h-full rounded-full ${hot ? 'bg-coral' : 'bg-amber'}`}
          style={{ width: `${Math.min(pct, 100)}%` }}
        />
      </div>
    </div>
  )
}

export default function StatsSidebar({ currency }) {
  const { loading, data } = useFetch(`${urlApi}/admin/driver-payments/review-stats${currency ? `?currency=${currency}` : ''}`)
  const stats = loading || !data || data.status ? null : data

  return (
    <div className='rounded-[24px] bg-white dark:bg-dk-surface ring-1 ring-warm_border dark:ring-dk-border shadow-sm p-6'>
      <p className='font-display font-bold text-[11px] tracking-[0.18em] uppercase text-coral mb-5'>Último mes</p>
      {!stats ? (
        <div className='flex flex-col gap-4'>
          <div className='pr-skeleton h-11 rounded-xl' />
          <div className='pr-skeleton h-11 rounded-xl' />
          <div className='pr-skeleton h-11 rounded-xl' />
        </div>
      ) : (
        <div className='flex flex-col gap-5'>
          <Stat label='Rechazados' value={stats.rejected_last_month} tone='coral' />
          <Stat label='Procesados' value={stats.processed_last_month} tone='ink' />
          <RatioStat ratio={stats.ratio} />
        </div>
      )}
    </div>
  )
}
